import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Translation from 'utils/Translation';

function BreadCrumb(props) {
    const location = useLocation();
    const path = location.pathname.toLowerCase();

    let midPath = null;

    if (path.includes('/hotel/lunishower')) {
        midPath = (
            <Link to="/hotel/Lunishower">
                LuniShower
            </Link>
        );
    } else if (path.includes('/hotel/greenmiles')) {
        midPath = (
            <Link to="/hotel/greenmiles">
                Greenmiles
            </Link>
        );
    }

    return (
        <div className="breadcrumb">
            <Link to="/hotel"><Translation tag="Your_hotel" /></Link>
            {midPath && <> / {midPath}</>}
            <div className="last_elem"> / <Translation tag={props.text} /></div>
        </div>
    );
}

export default BreadCrumb;
